/* global Event */

document.addEventListener('DOMContentLoaded', function() {

    document.addEventListener('click', function(e) {
        const item = e.target.closest('.ccs-grid-item');
        if (!item) {return;}

        const courseTitle = item.dataset.courseTitle || '';

        // get form id from section
        const section = document.querySelector('.course-catalog-section');
        if (!section) {return;}

        const formId = section.dataset.form;
        if (!formId) {return;}

        // target ONLY that gravity form
        const form = document.querySelector(`#gform_${formId}`);
        if (!form) {return;}

        const input = form.querySelector('.course_title input, input.course_title');

        if (input) {
            input.value = courseTitle;

            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });

});